"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
const styles = exports.styles = {
  muiTableContainerProps: {
    sx: {
      //stripe the rows, make odd rows a darker color
      "&::-webkit-scrollbar": {
        width: "1.125rem",
        height: "1.125rem"
      },
      "&::-webkit-scrollbar-thumb": {
        height: "0.375rem",
        border: "0.25rem solid rgba(0, 0, 0, 0)",
        backgroundClip: "padding-box",
        borderRadius: "0.625rem",
        backgroundColor: "rgba(81, 81, 81, 0.1)"
      },
      "&::-webkit-scrollbar-button": {
        width: 0,
        height: 0,
        display: "none"
      },
      "&::-webkit-scrollbar-corner": {
        backgroundColor: "transparent"
      }
    }
  },
  muiTableHeadCellFilterTextFieldProps: {
    variant: "outlined",
    size: "small"
  },
  muiTableBodyCellProps: {
    sx: {
      fontSize: "1rem",
      fontFamily: "Lato, sans-serif"
    }
  },
  muiTablePaperProps: {
    elevation: 0,
    //change the mui box shadow
    //customize paper styles
    sx: {
      borderRadius: "0",
      "& table": {
        border: "1px solid var(--light-blue-grey)",
        borderCollapse: "collapse"
      }
    }
  },
  muiTableBodyProps: {
    sx: {
      "& tr:nth-of-type(odd)": {
        backgroundColor: "var(--pale-grey)"
      },
      "& tr:hover": {
        boxShadow: "0 0 0.5rem 0.0625rem rgba(206, 212, 218, 0.8)"
      }
    }
  },
  muiTableBodyRowProps: {
    sx: {
      "&:hover td": {
        backgroundColor: "transparent"
      }
    }
  },
  muiTableHeadCellProps: {
    sx: {
      fontSize: "1rem",
      fontFamily: "Lato, sans-serif",
      " .MuiTableSortLabel-icon": {},
      " .MuiTableSortLabel-icon.MuiTableSortLabel-iconDirectionDesc": {},
      " .MuiTableSortLabel-icon.MuiTableSortLabel-iconDirectionAsc": {}
    }
  },
  muiTopToolbarProps: {
    sx: {
      overflow: "visible"
    }
  }
};